document.addEventListener("DOMContentLoaded", function () {
  const hostname = window.location.hostname;
  var requestOptions = {
    method: "GET",
  };
  var mycountry = getCookie("oblicua-country");

  if (hostname != "https://admin.shopify.com") {
    if (mycountry != null) {
      //Existe el pais
      console.log(mycountry);
      obl_redirect(mycountry);
    } else {
      fetch(
        "https://api.geoapify.com/v1/ipinfo?&apiKey=567965d60ca74d628cda0a399adab550",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) =>
          (function () {
            console.log("OK");
            // Access and use result.country.iso_code here
            mycountry = result.country.iso_code;
            setCookie("oblicua-country", mycountry, 30);
            obl_redirect(mycountry);
          })()
        )
        .catch((error) => console.log("error", error));
    }
  }
});

function obl_redirect(country) {
  const url = window.location.href;
  const includesString = url.startsWith("https://int.");


  if (country == "CO" && includesString) {
    location.href = "https://www.faobajoyas.com";
  }

  if (country != "CO" && !includesString) {
    location.href = "https://int.faobajoyas.com";
  }
}

function setCookie(cname, cvalue, exdays, path = "") {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/" + path;
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}
